import { DeliveryMode } from '../../../../../services/exports/Constants';

export default {
  header: 'Pauză comenzi noi',
  sections: {
    pause_orders: {
      title: 'Cât timp veți fi indisponibil?',
      description: 'Vom informa clienții că nu acceptați comenzi noi în prezent',
    },
    order_methods: {
      title: 'Metodele mele de comandă',
      description: 'Activați sau dezactivați metodele prin care clienții pot comanda',
    },
    delivery_mode: {
      title: 'Metode de livrare',
      description: 'Comutați între rețeaua dvs. și rețeaua noastră de șoferi',
    },
  },
  form: {
    orders_paused_until: {
      options: {
        '10_min': '10 min',
        '15_min': '15 min',
        '20_min': '20 min',
        '25_min': '25 min',
        '1_hour': '1 oră',
        '2_hours': '2 ore',
        rest_of_day: 'Restul zilei',
      },
    },
    has_standalone_delivery: {
      label: 'Șoferii mei',
    },
    has_external_delivery: {
      label: 'Rețeaua de șoferi {{provider}}',
    },
  },
  labels: {
    delivery_orders_off: 'Comenzi livrare oprite',
    delivery_orders_on: 'Comenzi livrare active',
  },
  modals: {
    toggle_delivery: {
      [true]: {
        title: 'Sigur doriți să activați comenzile de livrare?',
        description: '',
      },
      [false]: {
        title: 'Sigur doriți să dezactivați comenzile de livrare?',
        description: '',
      },
    },
    switch_delivery_mode: {
      [DeliveryMode.Internal]: {
        title: 'Sigur doriți să comutați la șoferii dvs.?',
        description: '',
      },
      [DeliveryMode.External]: {
        title: 'Sigur doriți să comutați la șoferii {{provider}}?',
        description: '',
      },
    },
  },
  buttons: {
    confirm: 'Confirmați',
    cancel: 'Anulați',
  },
  toasts: {
    failed_to_save_changes: 'Salvarea modificărilor a eșuat',
    changes_got_saved: 'Modificările au fost salvate cu succes',
  },
};
